<about-us-ui
    [contactForm]="contactForm"
    [countries]="countries$ | async"
    [isSubmitTriggered]="isSubmitTriggered"
    (contactFormClicked)="contactFormClicked()"></about-us-ui>